import { SuggestionDataService } from './../../services/suggestion-data.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { CheckupComponent } from './checkup/checkup.component';
import { Routes, RouterModule } from '@angular/router';
import { InvestorDetailsComponent } from './investor-details/investor-details.component';
import { InsuranceDetailsComponent } from './insurance-details/insurance-details.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { IncomeDetailsComponent } from './income-details/income-details.component';
import { AssetDetailsComponent } from './asset-details/asset-details.component';
import { GoalDetailsComponent } from './goal-details/goal-details.component';
import { AssetTabComponent } from './asset-details/asset-tab/asset-tab.component';
import { FormsModule } from '@angular/forms';
import { ScoreCardComponent } from './score-card/score-card.component';
import { AssetAllocationComponent } from './asset-allocation/asset-allocation.component';
import { BalanceComponent } from './balance/balance.component';
import { FinReportComponent } from './fin-report/fin-report.component';
import { InsuranceReportComponent } from './insurance-report/insurance-report.component';
import { AngularFirestoreModule } from '../../../../node_modules/angularfire2/firestore';
import { AngularFireStorageModule } from '../../../../node_modules/angularfire2/storage';
import { ManageComponent } from './reports/manage/manage.component';
import { BreakdownComponent } from './reports/breakdown/breakdown.component';
import { SuggestComponent } from './reports/suggest/suggest.component';
import { SuggestionReportComponent } from './suggestion-report/suggestion-report.component';
const checkupRoutes: Routes = [
  {
    path: 'checkup',
    children: [
      { path: '', component: CheckupComponent },
      {
        path: ':iid',
        component: CheckupComponent
      },
    ]
  }
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    RouterModule.forChild(checkupRoutes),
    MatExpansionModule,
    AngularFirestoreModule,
    AngularFireStorageModule
  ],
  providers: [
    SuggestionDataService
  ],
  declarations: [
    CheckupComponent,
    InvestorDetailsComponent,
    InsuranceDetailsComponent,
    IncomeDetailsComponent,
    AssetDetailsComponent,
    GoalDetailsComponent,
    AssetTabComponent,
    ScoreCardComponent,
    AssetAllocationComponent,
    BalanceComponent,
    FinReportComponent,
    InsuranceReportComponent,
    ManageComponent,
    BreakdownComponent,
    SuggestComponent,
    SuggestionReportComponent
  ]
})
export class HwcheckupModule { }



// WEBPACK FOOTER //
// ./src/app/modules/hwcheckup/hwcheckup.module.ts